import request from '@/utils/request'

const goodsType = {
  name: 'goodsType',
  state: {
    isGoodsTypeDetailLoading: false,
    goodsTypeDetailData: {}
  },

  mutations: {
    SET_IS_MODULES_GOODSTYPE_DETAIL_LOADING: (state, data) => {
      state.isGoodsTypeDetailLoading = data
    },
    SET_MODULES_GOODSTYPE_DETAIL_DATA: (state, data) => {
      state.goodsTypeDetailData = data
    }
  },

  actions: {
    //  获取账号编辑页面数据
    queryGoodsTypeDetailData({ commit }, id) {
      commit('SET_IS_MODULES_GOODSTYPE_DETAIL_LOADING', true)
      commit('SET_MODULES_GOODSTYPE_DETAIL_DATA', {})
      return new Promise((resolve, reject) => {
        request({
          url: '/modules/goodsType/goodsTypeDetail',
          method: 'post',
          data: { id: id }
        }).then(response => {
          commit('SET_IS_MODULES_GOODSTYPE_DETAIL_LOADING', false)
          commit('SET_MODULES_GOODSTYPE_DETAIL_DATA', response.data)
          resolve(response.data)
        }).catch(error => {
          commit('SET_IS_MODULES_GOODSTYPE_DETAIL_LOADING', false)
          reject(error)
        })
      })
    },
    //  重置账号新增页面数据
    resetGoodsTypeDetailData({ commit }) {
      commit('SET_MODULES_GOODSTYPE_DETAIL_DATA', {})
    }
  }
}

export default goodsType
